import { Component ,ElementRef} from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var jwplayer: any;

@Component({
  selector: 'app-content-detail',
  templateUrl: './content-detail.component.html',
  styleUrls: ['./content-detail.component.scss']
})
export class ContentDetailComponent {

  public loading:boolean = true;
  public DetailData:any=[];
  public EquipmentArray:any = [];
  public otherSelection:any='';
  public m_otherSelection:any='';
  public ms_otherSelection:any='';
  public d_otherSelection:any='';
  public s_otherSelection:any='';
  public c_otherSelection:any='';
  public freechcek:boolean=false;
  public sliderArray:any=[];
  public stepArray:any=[];
  public ingredianList:any=[];
  public videoUrl:any='';
  public showview:boolean=false;

  value: number = 1;
  options: Options = {
    showTicksValues: false,    
    showTicks: true,
    disabled:true,
    stepsArray: [
      {value: 0, legend: 'Low'},
      {value: 1250, legend: 'Medium'},
      {value: 2500, legend: 'High'}
    ],
  };

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) { 
    // this.DetailData= JSON.parse(localStorage.getItem('gra_EditData')||'{}');
    this.getDetail();

  }

  ngOnInit(): void {
  } 

  getDetail(){
    var detail={ "id":localStorage.getItem('gra_postid')};
    this.service.PostApis(detail,'/singles-detail').subscribe(((response:any)=>{
        if(response.success ==1) {
          var self=this;
          if(response.data.thumbnail ==''){
            response.data.thumbnail = 'assets/images/default_img.png';   
          }
         
          if(response.data.user_detail.length !=0){
            response.data.creater_name =response.data.user_detail[0].name+' '+ response.data.user_detail[0].surname;
          }
          if((response.data.post_type == 1 || response.data.post_type == 2 || response.data.post_type == 3) && response.data.post_category == 1  ){
            this.sliderArray=
            [ {id:1,name:'Balance',text:'balance', value:response.data.balance},
              {id:2,name:'Flexibility',text:'flexibility', value:response.data.flexibility},
              {id:3,name:'Focus',text:'focus', value:response.data.focus},
              {id:4,name:'Strength',text:'strength', value:response.data.strength},
              {id:5,name:'Endurance',text:'endurance', value:response.data.endurance},
            ];
          }
          if((response.data.post_type == 1 || response.data.post_type == 2 || response.data.post_type == 3)  && response.data.post_category == 2  ){
            if(response.data.post_type == 1){
              this.sliderArray=
              [ {id:1,name:'Calories',text:'balance', value:response.data.avg_calories},
              ];
            } 
            if(response.data.post_type == 2){
              this.sliderArray=
              [ {id:1,name:'Calories',text:'balance', value:response.data.calories},
              ];
            } 
            if(response.data.post_type == 3){
              this.sliderArray=
              [ {id:1,name:'Calories',text:'balance', value:response.data.avg_calories},
              ];
            }
            if(response.data.diet_other.length != 0){
              response.data.diet_other =response.data.diet_other[0].content;
            }
          
            if(response.data.subcategory_other.length != 0){
              response.data.subcategory_other =response.data.subcategory_other[0].content;
            }
            if(response.data.diet.length != 0){
              response.data.diet.filter((el:any)=>{
                if(el.childContent == true){
                  self.d_otherSelection = el._id;
                }
              })
            }
            if(response.data.sub_category.length != 0){
              response.data.sub_category.filter((el:any)=>{
                if(el.childContent == true){
                  self.s_otherSelection = el._id;
                }
              })
            }
         
          }
          if((response.data.post_type == 1 && response.data.post_category == 2 ) || response.data.post_type == 3 || response.data.post_type == 2){
            if(response.data.post_steps !=''){
            // var mm:any= response.data.post_steps.split(',');
            var count=1;  
            response.data.post_steps.filter((el:any)=>{
              self.stepArray.push({id :count,textdisabled: true,checkdisabled:false,text:el.steps})
              count=count+1;
            }) 
          }
          }
          if(((response.data.post_type == 1  || response.data.post_type == 2 || response.data.post_type == 3 ) && response.data.post_category == 2 ) ){
            if(response.data.ingredients !=''){
              var jj:any= response.data.ingredients.split(',');
              jj.filter((el:any)=>{
                self.ingredianList.push(el);              
              }) 
            }           
          }
          if(response.data.post_type == 1){
            this.freechcek = response.data.is_content_free;   
          } 
          if((response.data.post_type == 1 ||response.data.post_type == 2 || response.data.post_type == 3 ) && response.data.post_category == 1  ){
            if(response.data.post_equipment_sets_reps.length != 0){
              var count=1;
              response.data.post_equipment_sets_reps.filter((el:any)=>{
                self.EquipmentArray.push({id: count,equipment: el.equipment,sets: el.sets,reps:el.reps});
                count=count+1;
              })
            } else {
              self.EquipmentArray.push({id: 1,equipment: '',sets: '',reps:''});
            }

            if(response.data.other_type.length != 0){
              response.data.type_other =response.data.other_type[0].content;
            }
            if(response.data.type.length != 0){
              response.data.type.filter((el:any)=>{
                if(el.childContent == true){
                  self.otherSelection = el._id;
                }
              })
            }
          }

          if(response.data.content !='' ){
            if(response.data.post_type==1 || response.data.post_type==3){
            //   this.videoUrl = this.service.playerBase+response.data.content +'-9fdkfJgJ.html';
            //   //  data.dimensions[0].player_id+'.html'; 
            //   // this.videoUrl = this.service.playerBase+response.data.content +'-'+ response.data.dimensions[0].player_id+'.html';       
            // } else {
              this.videoUrl =response.data.content;
            }
          }      
                    
          if(response.data.medical_condition.length != 0){
            response.data.medical_condition.filter((el:any)=>{
              if(el.childContent == true){
                self.m_otherSelection = el._id;
              }
              if(el.subchildContent==true){
                self.ms_otherSelection =el._id;
              }
            })
          }
          if(response.data.medical_other.length != 0){
            response.data.medical_other =response.data.medical_other[0].content;
          } 
          // console.log( response.data.content);
          this.DetailData = response.data;
          this.showview=true;
          this.loading=false;
        } else {
          this.loading=false;
        }
    }))
  }
}
